<template>
    <div>
        <container :active_path="path" :plate="'云项目'">

            <div class="base-warp">
                <div class="head">
                    <el-form :model="form" label-width="80px" :inline="true" size="mini">
                        <el-form-item label="楼盘名称">
                            <el-autocomplete v-model="form.project" 
                                value-key="name" 
                                placeholder="输入楼盘名称" 
                                clearable
                                size="mini"
                                :fetch-suggestions="querySearchAsync" 
                                @clear="form.projectid = ''" 
                                @select="handleSelect">
                            </el-autocomplete>
                        </el-form-item>
                        <el-form-item label="文章名称">
                            <el-input v-model="form.name" placeholder="请输入文章名称"></el-input>
                        </el-form-item>
                        <el-form-item label="类型">
                            <el-select v-model="form.types" placeholder="文章类型" size="mini" clearable>
                                <el-option :label="item" :value="item" v-for="(item, index) in atypes" :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="confirm">搜索</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="add">添加文章</el-button>
                        </el-form-item>
                    </el-form>
                </div>

                <div class="table-box">
                    <el-table 
                    :data="tabledata" 
                    border 
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="index" label="序号" width="60"></el-table-column>
                        <el-table-column prop="title" label="标题" show-overflow-tooltip=""></el-table-column>
                        <el-table-column prop="type" label="类型" align="center"></el-table-column>
                        <el-table-column prop="city" label="关联城市" align="center"></el-table-column>
                        <el-table-column prop="projectid" label="关联楼盘" width="220">
                            <template slot-scope="s">
                                <div class="flex-box">
                                    <span class="text projectname" v-if="s.row.project">{{s.row.project.name}}</span>
                                    <dynamic-project :eid="s.row._id['$oid']" :project="s.row.project" :managedCity="managedCity" :city="s.row.city" :regions="regions" :key="s.row._id['$oid']"></dynamic-project>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="click" label="阅读量" align="center"></el-table-column>
                        <el-table-column prop="zanlen" label="点赞" align="center"></el-table-column>
                        <el-table-column prop="putaway" label="状态" align="center">
                            <template slot-scope="s">
                                <span class="text-success" v-if="s.row.putaway">上架</span>
                                <span class="text-danger" v-else>下架</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="210">
                            <template slot-scope="s">
                                <el-button type="warning" v-if="s.row.putaway" size="mini" @click="putaway(s.row)">下架</el-button>
                                <el-button type="success" v-if="!s.row.putaway" size="mini" @click="putaway(s.row)">上架</el-button>
                                <el-button type="danger" size="mini" @click="del(s.row)">删除</el-button>
                                <el-button type="primary" size="mini" @click="edit(s.row)" plain>编辑</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
            </div>
        </container>
        <router-view></router-view>
    </div>
</template>

<script>
import container from '../../../components/container.vue'
import DynamicProject from '../../../components/dynamic-project.vue';
export default {
    components: { container, DynamicProject },
    data() {
        return {
            path: '/project/dynamic',
            form: {
                project:'',
                projectid: '',
                name: '',
                types: '',
            },
            atypes: ['动态', '点评'],
            pageNo: 1,
            pagesize: 14,
            total: 0,
            tabledata: [],
            regions: [],
            isAllCity:true,
            managedCity:'',
        }
    },
    mounted () {
        const managedCity = this.$store.getters.getuser.city;
        if(managedCity === '全部'){
            this.isAllCity = true;
        }else{
            this.isAllCity = false;
            this.managedCity = managedCity;
        }
        this.getTableData();
    },
    methods: {
        putaway(row) {
            var params = {
                id: row._id['$oid'],
                putaway: !row.putaway
            }
            this.$api.putAwayProjectDynamic(params).then(
                data=>{
                    this.$message.success(data);
                    this.getTableData();
                }
            )
        },
        del(row) {
            this.$confirm('是否确定删除当前文章').then(
                confirm=>{
                    var params = {
                        id: row._id['$oid']
                    }
                    this.$api.delProjectDynamic(params).then(
                        data=>{
                            this.$message.success(data);
                            this.getTableData();
                        }
                    )
                },
                cancel=>{}
            )
        },
        edit(row) {
            var id = row._id['$oid'];
            let selectedCity = row.city;
            let isAllCity = this.isAllCity
            this.$router.push({path: '/project/dynamic/edit', query:{id,selectedCity,isAllCity}});
        },
        getTableData() {
            var params = {
                projectid: this.form.projectid,
                name: this.form.name,
                types: this.form.types,
                pageNo: this.pageNo,
                pagesize: this.pagesize,
                city:this.managedCity,
            }
            this.$api.getProjectDynamicList(params).then(
                data=>{
                    let {list, total} = data;
                    this.tabledata = list;
                    this.total = total;
                }
            )
        },
        add() {
            let isAllCity = this.isAllCity
            let selectedCity = this.managedCity
            this.$router.push({path: '/project/dynamic/add',query:{isAllCity,selectedCity}})
        },
        confirm() {
            this.pageNo = 1;
            this.getTableData();
        },
        currentChange(page) {
            this.pageNo = page;
            this.getTableData();
        },
        querySearchAsync(queryString, cb) {
            if (this.loading) return;
            var params = {
                name: queryString||'',
                region: '',
                price: '',
                pageNo: 1,
                pagesize: 5,
            }
            this.loading = true;
            this.$api.getProjectList(params).then(
                data=>{
                    this.loading = false;
                    let {list} = data;
                    cb(list);
                }
            )
        },
        handleSelect(item) {
            this.form.projectid = item._id['$oid'];
        },
    },
    beforeRouteUpdate(to, from, next) {
        if (from.path == "/project/dynamic/add"||from.path=='/project/dynamic/edit'){
            this.getTableData();
        }
        next();
    },
}
</script>

<style lang="scss" scoped>
.text{
    margin-right: 10px;
}
.projectname{
    width: 150px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
</style>